import { useSelector } from "react-redux";
import {
  selectUserPermissions,
  selectAimsPermission,
  selectHeadlessPermission,
  selectPitchesPermission,
  selectRoasterPermission,
  selectEmailPermission,
  type Permission,
} from "../store/slices/userSlice";

export const useUserPermissions = () => {
  const permissions = useSelector(selectUserPermissions);
  const aims = useSelector(selectAimsPermission);
  const headless = useSelector(selectHeadlessPermission);
  const pitches = useSelector(selectPitchesPermission);
  const roaster = useSelector(selectRoasterPermission);
  const email = useSelector(selectEmailPermission);

  const getPermission = (type: string): Permission | undefined => {
    return permissions.find(p => p.type === type);
  };

  return {
    aims,
    headless,
    pitches,
    roaster,
    email,
    getPermission,
    permissions,
  };
};
